import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { setCountryCode, setToken } from 'store/common/utils';
import { abortController } from 'store/utils';
import { loginApi, logoutApi, forgotPasswordApi, resetPasswordApi, getUserApi, validateEmailApi, changePasswordApi, userUpdateApi, } from './api';
const authToken = window.localStorage.getItem('token');
const initialState = {
    token: authToken,
    user: null,
};
const actions = {
    logout: async (payload, { setState }) => {
        try {
            await logoutApi();
        }
        catch (error) {
            // @ts-ignore
            throw error?.response?.data?.errors;
        }
        localStorage.setItem('token', '');
        localStorage.setItem('role', '');
        window.location.href = '/';
        setState({ token: false });
    },
    login: async ({ email, password }, { setState }) => {
        try {
            const { data: { token } } = await loginApi({ email, password });
            window.localStorage.setItem('token', token);
            setToken(`Bearer ${token}`);
            setState({ token });
        }
        catch (error) {
            // @ts-ignore
            throw error.response.data.message;
        }
    },
    getUser: async (payload, { signal, setState }) => {
        try {
            const { data: user } = await getUserApi(signal);
            const { role, country } = user;
            if (!country.available.length)
                throw '403'; // TODO позже будем редиректить на страницу 403 или на логин с нотификацией, если у юзера нет доступа к странам
            localStorage.setItem('role', role);
            const localStorageCountry = localStorage.getItem('countryCode');
            const countryForLogin = localStorageCountry || country.default;
            if (country.available.includes(countryForLogin)) {
                setCountryCode(countryForLogin);
            }
            else {
                setCountryCode(country.available[0]);
            }
            setState({ user }, 'fulfilled');
            return user;
        }
        catch (error) {
            // @ts-ignore
            throw error.response.data.errors;
        }
    },
    updateUser: async (payload, { setState }) => {
        try {
            const { data: user } = await userUpdateApi(payload);
            setState({ user });
            return user;
        }
        catch (error) {
            // @ts-ignore
            throw error.response.data.errors;
        }
    },
    forgotPassword: async (email) => {
        try {
            const { data } = await forgotPasswordApi({ email });
            return data;
        }
        catch (error) {
            // @ts-ignore
            throw error.response.data.errors;
        }
    },
    resetPassword: async (payload) => {
        try {
            const { data } = await resetPasswordApi(payload);
            return data;
        }
        catch (error) {
            // @ts-ignore
            throw error.response.data.errors;
        }
    },
    validateEmail: async (payload) => {
        try {
            const { data } = await validateEmailApi(payload);
            if (!data.isAvailable)
                throw new Error('emailIsNotAvailable');
            return data;
        }
        catch (error) {
            // @ts-ignore
            throw error?.message;
        }
    },
    changePassword: async (payload) => {
        try {
            const { data } = await changePasswordApi(payload);
            return data;
        }
        catch (error) {
            // @ts-ignore
            throw error.response.data.errors;
        }
    },
};
const store = { ...initialState, ...actions };
export default create()(devtools(immer((set, get) => abortController(store, set, get, 'Auth')), {
    name: 'Auth',
}));
setToken(`Bearer ${authToken}`);
